var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"locale-changer"},[_c('v-select',{attrs:{"prepend-icon":"mdi-flag","items":_vm.locales,"item-text":"label","item-value":"value"},model:{value:(_vm.$i18n.locale),callback:function ($$v) {_vm.$set(_vm.$i18n, "locale", $$v)},expression:"$i18n.locale"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }